import { useState, useContext, useEffect } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { Grid,  } from '@mui/material';
import XMLFilesContext from '../../contexts/XMLFilesContexts';
import { computeOffsetLeft } from '@mui/x-data-grid/hooks/features/virtualization/useGridVirtualScroller';


export default function MCChart( props ) {
  const [rendered, setRendered] = useState(false);
  //const [contatosMonth, setContatosMonth] = useState([]);
  const{title, series, labels} = {...props}
  const { 
    growthData,
    dataSets,
    growthDataRows,
    growthDataLoaded,
    setGrowthDataLoaded,
    setGrowthData,
    setGrowthDataRows,
    syncGrowthData,
    saveGrowthDataLine,
    setDataSets  } = useContext(XMLFilesContext);

    function calculateDataSets( ) {
      setRendered(false);
      const currentData = new Date(Date.now());
      const pastTwelveMonths = new Date( Date.now() - 365 * 24 * 60 * 60 * 1000); // days * hours * minutes * seconds * milliseconds
      const currentYear = currentData.getFullYear();
     
      const currentMonth = currentData.getMonth() + 1; //Alterarar para + 1 antes de colocar em produção
      const currentDay = currentData.getDate();

      const lastMonth = pastTwelveMonths.getMonth() - 1;
      const lastYear = pastTwelveMonths.getFullYear();

      // console.log( "Growth Data Rows: ", growthDataRows );
      // console.log( "Current Month: ", currentMonth);
      // console.log("Current Year: ", currentYear);

      //Obtem os datasets brutos para cada gráfico - mes atual, ano corrente e ultimos 12 meses
      const currentMonthData = growthDataRows.filter((row) => row.month === currentMonth && row.year === currentYear);
      const currentYearData = growthDataRows.filter((row) => row.year === currentYear);
      const lastTwelveMonthsData = growthDataRows.filter((row) => 
        (row.year === currentYear && row.month <= currentMonth) || 
        ( row.year === lastYear && row.month >= lastMonth ) ) 

      //Constantes dos sumários por nível de agente
      const currentMonthDaySummaryObjects = [];
      const currentYearSummaryObjects = [];
      const lastTwelveMonthsSummaryObjects = [];

      const agentInitialSummary = {contratacoes: 0, reunioes: 0, contatos: 0}
      const agentSummaryInitialState = { 
        'R0': {...agentInitialSummary}, 
        'R1': {...agentInitialSummary}, 
        'R2': {...agentInitialSummary} 
      }
      const currentMonthAgentLevelSummary = {...agentSummaryInitialState }
      const lastTwelveMonthsAgentLevelSummary = {...agentSummaryInitialState }
      const currentYearAgentLevelSummary = {...agentSummaryInitialState }

      //Os DataSets que vão para os gráficos
      const contratacoesMonthDataSet = [];
      const reunioesMonthDataSet = [];
      const contatosMonthDataSet = [];
      const contratacoesCurrentYearDataSet = [];
      const reunioesCurrentYearDataSet = [];
      const contatosCurrentYearDataSet = [];
      const contratacoesLastTwelveMonthsDataSet = [];
      const reunioesLastTwelveMonthsDataSet = [];
      const contatosLastTwelveMonthsDataSet = [];
      
      //Gera os datasets do gráfico de mes corrente
      console.log( "Current Month Data: ", currentMonthData );
      currentMonthData.forEach( el => {
        console.log('El for Daily summary: ', el)
        currentMonthDaySummaryObjects[el.day - 1] = {
          contratacoes: currentMonthDaySummaryObjects[el.day - 1]?.contratacoes === undefined ?
            el.contratacoes : currentMonthDaySummaryObjects[el.day - 1]?.contratacoes + el.contratacoes,
          reunioes: currentMonthDaySummaryObjects[el.day - 1]?.reunioes === undefined ?
            el.reunioes : currentMonthDaySummaryObjects[el.day - 1]?.reunioes + el.reunioes,
          contatos: currentMonthDaySummaryObjects[el.day - 1]?.contatos === undefined ?
            el.contatos : currentMonthDaySummaryObjects[el.day - 1]?.contatos + el.contatos
        };
        console.log('currentMonthDaySummaryObjects: ', currentMonthDaySummaryObjects)
        console.log('Daily summary: ', currentMonthDaySummaryObjects[el.day])
        currentMonthAgentLevelSummary[el.nivelAgente] = {
          contratacoes: currentMonthAgentLevelSummary[el.nivelAgente].contratacoes + el.contratacoes,
          reunioes: currentMonthAgentLevelSummary[el.nivelAgente].reunioes + el.reunioes,
          contatos: currentMonthAgentLevelSummary[el.nivelAgente].contatos + el.contatos,
        }
      }) 



      Object.keys(currentMonthDaySummaryObjects).forEach( day => {

          //console.log( currentMonthDaySummaryObjects );

        contratacoesMonthDataSet.push(currentMonthDaySummaryObjects[day].contratacoes);
        reunioesMonthDataSet.push(currentMonthDaySummaryObjects[day].reunioes);
        contatosMonthDataSet.push(currentMonthDaySummaryObjects[day].contatos);
      })
//console.log( currentMonthDaySummaryObjects )
      //Current Year calculations
      //console.log( "Current Year Data: ", currentYearData );
      currentYearData.forEach( el => {
       // console.log( "Current Year Data el: ", el );
       // console.log( "currentYearSummaryObjects: ", currentYearSummaryObjects );
        currentYearSummaryObjects[`${el.month}`] = {
          contratacoes: 
            currentYearSummaryObjects[`${el.month}`]?.contratacoes === undefined ?
              el.contratacoes : currentYearSummaryObjects[`${el.month}`]?.contratacoes + el.contratacoes,
          reunioes: currentYearSummaryObjects[`${el.month}`]?.reunioes === undefined ?
            el.reunioes  :  currentYearSummaryObjects[`${el.month}`].reunioes + el.reunioes,
          contatos: currentYearSummaryObjects[`${el.month}`]?.contatos === undefined ? 
            el.contatos : currentYearSummaryObjects[`${el.month}`].contatos + el.contatos
        }

        currentYearAgentLevelSummary[el.nivelAgente] = {
          contratacoes: currentYearAgentLevelSummary[el.nivelAgente].contratacoes + el.contratacoes,
          reunioes: currentYearAgentLevelSummary[el.nivelAgente].reunioes + el.reunioes,
          contatos: currentYearAgentLevelSummary[el.nivelAgente].contatos + el.contatos,
        }
      })
     // console.log("CurrentYearSummaryObject:", currentYearSummaryObjects)
      Object.keys(currentYearSummaryObjects).forEach( month => {
        //console.log("MONTH is: ", month)
        contratacoesCurrentYearDataSet.push(currentYearSummaryObjects[month].contratacoes);
        reunioesCurrentYearDataSet.push(currentYearSummaryObjects[month].reunioes);
        contatosCurrentYearDataSet.push(currentYearSummaryObjects[month].contatos);
      })

      //ultimos 12 meses calculations
      lastTwelveMonthsData.forEach( el => {
        lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`] = {
          contratacoes: lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`]?.contratacoes === undefined ?
           el.contratacoes : lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`]?.contratacoes + el.contratacoes,
          reunioes: lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`]?.reunioes === undefined ?
           el.reunioes : lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`].reunioes + el.reunioes,
          contatos: lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`]?.contatos === undefined ? 
           el.contatos : lastTwelveMonthsSummaryObjects[`${el.month}/${el.year}`].contatos + el.contatos
        } 
        //console.log( "Nivel Agente: ", el.nivelAgente, " Contratacoes: ", el.contratacoes, " Reunioes: ", el.reunioes )
        lastTwelveMonthsAgentLevelSummary[el.nivelAgente] = {
          contratacoes: lastTwelveMonthsAgentLevelSummary[el.nivelAgente].contratacoes === undefined ?
           el.contratacoes : lastTwelveMonthsAgentLevelSummary[el.nivelAgente].contratacoes + el.contratacoes,
          reunioes: lastTwelveMonthsAgentLevelSummary[el.nivelAgente].reunioes === undefined ?
           el.reunioes : lastTwelveMonthsAgentLevelSummary[el.nivelAgente].reunioes + el.reunioes,
          contatos: lastTwelveMonthsAgentLevelSummary[el.nivelAgente].contatos === undefined ?
           el.contatos : lastTwelveMonthsAgentLevelSummary[el.nivelAgente].contatos + el.contatos
        }
      })

      Object.keys(lastTwelveMonthsSummaryObjects).forEach(  month => {
        console.log("MONTH is: ", month)
        contratacoesLastTwelveMonthsDataSet.push(lastTwelveMonthsSummaryObjects[month].contratacoes);
        reunioesLastTwelveMonthsDataSet.push(lastTwelveMonthsSummaryObjects[month].reunioes);
        contatosLastTwelveMonthsDataSet.push(lastTwelveMonthsSummaryObjects[month].contatos);
      })

      //console.log( contratacoesMonthDataSet )
      setDataSets({
        contratacoesMonthDataSet,
        reunioesMonthDataSet,
        contatosMonthDataSet,
        contratacoesCurrentYearDataSet,
        reunioesCurrentYearDataSet,
        contatosCurrentYearDataSet,
        contratacoesLastTwelveMonthsDataSet,
        reunioesLastTwelveMonthsDataSet,
        contatosLastTwelveMonthsDataSet,
        currentMonthAgentLevelSummary,
        lastTwelveMonthsAgentLevelSummary,
        currentYearAgentLevelSummary,
        //Eixos X dos gráficos
        monthDaysAxis: Object.keys(currentMonthDaySummaryObjects).map( 
          day => `${+day < 9 ? "0" + (+day + 1) : +day + 1}/${currentMonth < 10 ? "0" + currentMonth : currentMonth }` ),
        currentYearAxis: Object.keys(currentYearSummaryObjects).map( 
          month => `${+month < 9 ? "0" + (+month) : +month}/${currentYear}` ),
        lastTwelveMonthsAxis: Object.keys(lastTwelveMonthsSummaryObjects)
      })
      //alert( dataSets.lastTwelveMonthsAxis )
      //setContatosMonth(contatosMonthDataSet);
      //console.log("Current Month Data is: ", currentMonthDaySummaryObjects);

       //console.log("Current Month Data by agente Level is: ", currentMonthAgentLevelSummary);
       setRendered(true);
    }

    useEffect( () => {
      calculateDataSets();
    }, [ ] );

    useEffect( () => {
      calculateDataSets();
      //console.log("Data Sets: ", dataSets);
    }, [growthDataRows] );

  return <Grid container spacing={1}
      justifyItems='flex-start' 
      alignItems={'flex-start'}>
      
        <Grid item xs={12} sm={10} style={{ textAlign: 'left', }}>
          
        { rendered &&
        <div>
        <Grid container spacing={5} justifyItems='flex-start' alignItems={'flex-start'}>
          <Grid item xs={5} sm={5} style={{ textAlign: 'left', }}>
            <h3>Mês Corrente ( {((new Date( Date.now() )).getMonth() + 1) < 10 ? `0${(new Date( Date.now() )).getMonth() + 1}/${(new Date( Date.now() )).getFullYear()}` : `${(new Date( Date.now() )).getMonth() + 1}/${(new Date( Date.now() )).getFullYear()}`} )</h3>
            <LineChart
              width={500}
              height={300}
              series={ [{data: dataSets.contatosMonthDataSet, label: 'contatos'},
              {data: dataSets.reunioesMonthDataSet, label: 'reuniões'},
              {data: dataSets.contratacoesMonthDataSet, label: 'contratacoes'} ] }
              xAxis={[{ scaleType: 'point', data: dataSets.monthDaysAxis}]}
            />
          </Grid>
          <Grid item xs={1} sm={1}></Grid>
          <Grid item xs={6} sm={5} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
            <h3>Resumo</h3>
            <Grid container spacing={2} justifyItems='flex-start' alignItems={'flex-start'}>
              <Grid item xs={2} sm={2} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
                  <h4>Atividade</h4>
                  <p>Contatos:</p>
                  <p>Reuniões:</p>
                  <p>Contratações:</p>
                </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
                <h4>R0</h4>
                <p>{dataSets.currentMonthAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
                <h4>R1</h4>
                <p>{dataSets.currentMonthAgentLevelSummary.R1.contatos}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R1.reunioes}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R1.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
                <h4>R2</h4>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.contatos}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.reunioes}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.contratacoes}</p>
              </Grid>
              <Grid item xs={2} sm={2} style={{ textAlign: 'left', padding: '5px', margin: '10px'}}>
                <h4>Totais</h4>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.contatos
                  + dataSets.currentMonthAgentLevelSummary.R1.contatos
                  + dataSets.currentMonthAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.reunioes
                + dataSets.currentMonthAgentLevelSummary.R1.reunioes
                + dataSets.currentMonthAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.currentMonthAgentLevelSummary.R2.contratacoes
                + dataSets.currentMonthAgentLevelSummary.R1.contratacoes
                + dataSets.currentMonthAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>Taxa</h4>
                <p>-</p>
                <p>{((dataSets.currentMonthAgentLevelSummary.R2.reunioes
                + dataSets.currentMonthAgentLevelSummary.R1.reunioes
                + dataSets.currentMonthAgentLevelSummary.R0.reunioes)
                / (dataSets.currentMonthAgentLevelSummary.R2.contatos
                  + dataSets.currentMonthAgentLevelSummary.R1.contatos
                  + dataSets.currentMonthAgentLevelSummary.R0.contatos)).toFixed(3)}</p>
                <p>{((dataSets.currentMonthAgentLevelSummary.R2.contratacoes
                + dataSets.currentMonthAgentLevelSummary.R1.contratacoes
                + dataSets.currentMonthAgentLevelSummary.R0.contratacoes)
                / (dataSets.currentMonthAgentLevelSummary.R2.reunioes
                  + dataSets.currentMonthAgentLevelSummary.R1.reunioes
                  + dataSets.currentMonthAgentLevelSummary.R0.reunioes)).toFixed(3)}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={5} justifyItems='flex-start' alignItems={'flex-start'}>
          <Grid item xs={5} sm={5} style={{ textAlign: 'left', }}>
            <h3>Ano Corrente {(new Date( Date.now() )).getFullYear() }</h3>
            <LineChart
              width={500}
              height={300}
              series={ [{data: dataSets.contatosCurrentYearDataSet, label: 'contatos'},
              {data: dataSets.reunioesCurrentYearDataSet, label:'reuniões'},
              {data: dataSets.contratacoesCurrentYearDataSet, label: 'contratacoes'} ] }
              xAxis={[{ scaleType: 'point', data: dataSets.currentYearAxis}]}
            /> 
          </Grid>
          <Grid item xs={1} sm={1}></Grid>
          <Grid item xs={6} sm={5} >
            <h3>Resumo</h3>
            <Grid container justifyItems='flex-start' alignItems={'flex-start'}>
              <Grid item xs={3} sm={3} style={{ textAlign: 'left', padding: '5px'}}>
                  <h4>Atividade</h4>
                  <p>Contatos:</p>
                  <p>Reuniões:</p>
                  <p>Contratações:</p>
                </Grid>
              <Grid item xs={1} sm={1} >
                <h4>R0</h4>
                <p>{dataSets.currentYearAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1}>
                <h4>R1</h4>
                <p>{dataSets.currentYearAgentLevelSummary.R1.contatos}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R1.reunioes}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R1.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} >
                <h4>R2</h4>
                <p>{dataSets.currentYearAgentLevelSummary.R2.contatos}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R2.reunioes}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R2.contratacoes}</p>
              </Grid>
              <Grid item xs={2} sm={2} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>Totais</h4>
                <p>{dataSets.currentYearAgentLevelSummary.R2.contatos
                  + dataSets.currentYearAgentLevelSummary.R1.contatos
                  + dataSets.currentYearAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R2.reunioes
                + dataSets.currentYearAgentLevelSummary.R1.reunioes
                + dataSets.currentYearAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.currentYearAgentLevelSummary.R2.contratacoes
                + dataSets.currentYearAgentLevelSummary.R1.contratacoes
                + dataSets.currentYearAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>Taxa</h4>
                <p>-</p>
                <p>{((dataSets.currentYearAgentLevelSummary.R2.reunioes
                + dataSets.currentYearAgentLevelSummary.R1.reunioes
                + dataSets.currentYearAgentLevelSummary.R0.reunioes)
                / (dataSets.currentYearAgentLevelSummary.R2.contatos
                  + dataSets.currentYearAgentLevelSummary.R1.contatos
                  + dataSets.currentYearAgentLevelSummary.R0.contatos)).toFixed(3)}</p>
                <p>{((dataSets.currentYearAgentLevelSummary.R2.contratacoes
                + dataSets.currentYearAgentLevelSummary.R1.contratacoes
                + dataSets.currentYearAgentLevelSummary.R0.contratacoes)
                / (dataSets.currentYearAgentLevelSummary.R2.reunioes
                  + dataSets.currentYearAgentLevelSummary.R1.reunioes
                  + dataSets.currentYearAgentLevelSummary.R0.reunioes)).toFixed(3)}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        
        <Grid container spacing={5} justifyItems='flex-start' alignItems={'flex-start'}>
          <Grid item xs={5} sm={5} style={{ textAlign: 'left', }}>
            <h3>Últimos 12 meses</h3>
            <LineChart
              width={500}
              height={300}
              series={ [{data: dataSets.contatosLastTwelveMonthsDataSet, label: 'contatos'},
              {data: dataSets.reunioesLastTwelveMonthsDataSet, label:'reuniões'},
              {data: dataSets.contratacoesLastTwelveMonthsDataSet, label: 'contratacoes'} ] }
              xAxis={[{ scaleType: 'point', data: dataSets.lastTwelveMonthsAxis}]}
            />
          </Grid>
          <Grid item xs={1} sm={1}></Grid>
          <Grid item xs={5} sm={5} style={{ textAlign: 'left', padding: '5px'}}>
            <h3>Resumo</h3>
            <Grid container  justifyItems='flex-start' alignItems={'flex-start'}>
              <Grid item xs={3} sm={3} style={{ textAlign: 'left', padding: '5px'}}>
                  <h4>Atividade</h4>
                  <p>Contatos:</p>
                  <p>Reuniões:</p>
                  <p>Contratações:</p>
                </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>R0</h4>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>R1</h4>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R1.contatos}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R1.reunioes}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R1.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>R2</h4>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.contatos}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.reunioes}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.contratacoes}</p>
              </Grid>
              <Grid item xs={2} sm={2} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>Totais</h4>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.contatos
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R1.contatos
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R0.contatos}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.reunioes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R1.reunioes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R0.reunioes}</p>
                <p>{dataSets.lastTwelveMonthsAgentLevelSummary.R2.contratacoes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R1.contratacoes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R0.contratacoes}</p>
              </Grid>
              <Grid item xs={1} sm={1} style={{ textAlign: 'left', padding: '5px'}}>
                <h4>Taxa</h4>
                <p>-</p>
                <p>{((dataSets.lastTwelveMonthsAgentLevelSummary.R2.reunioes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R1.reunioes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R0.reunioes)
                / (dataSets.lastTwelveMonthsAgentLevelSummary.R2.contatos
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R1.contatos
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R0.contatos)).toFixed(3)}</p>
                <p>{((dataSets.lastTwelveMonthsAgentLevelSummary.R2.contratacoes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R1.contratacoes
                + dataSets.lastTwelveMonthsAgentLevelSummary.R0.contratacoes)
                / (dataSets.lastTwelveMonthsAgentLevelSummary.R2.reunioes
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R1.reunioes
                  + dataSets.lastTwelveMonthsAgentLevelSummary.R0.reunioes)).toFixed(3)}</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        </div>
        }
      </Grid>
      
    </Grid>

  
}